import type { CommissionPreview, CommissionRuleView } from "@cx/contracts";
import { formatPct, type CommissionBase } from "@cx/domain";

export const COMMISSION_BASE_LABEL: Record<CommissionBase, string> = {
  invoiced: "Faturado",
  received: "Recebido",
};

/** Faixa do desconto concedido: "de 5% a 10%", "a partir de 5%", "até 10%" ou "qualquer desconto". */
export function bandText(from: number | null, to: number | null): string {
  if (from !== null && to !== null) return `de ${formatPct(from)} a ${formatPct(to)}`;
  if (from !== null) return `a partir de ${formatPct(from)}`;
  if (to !== null) return `até ${formatPct(to)}`;
  return "qualquer desconto";
}

/** Alvo da regra na tabela: produto (com SKU) ou "Todos os produtos". */
export function ruleTargetText(r: Pick<CommissionRuleView, "productName" | "sku">): string {
  if (!r.productName) return "Todos os produtos";
  return r.sku ? `${r.productName} (${r.sku})` : r.productName;
}

const LEVEL: Record<CommissionPreview["level"], string> = {
  1: "regra do vendedor para o produto",
  2: "regra do vendedor para a categoria",
  3: "regra do vendedor por faixa de desconto",
  4: "regra geral do produto",
  5: "regra geral da categoria",
  6: "comissão padrão do vendedor",
};

/** Origem do percentual na simulação (precedência do 05 §6). */
export const commissionSourceText = (p: Pick<CommissionPreview, "level">) => LEVEL[p.level];
